import {ChangeDetectorRef, Component, ComponentFactoryResolver, ViewEncapsulation,} from '@angular/core';
import {ConfirmationService, MessageService} from 'primeng/api';
import {TranslateService} from '@ngx-translate/core';
import {FieldRecord} from "../../../model/api/field-record";
import {FieldRequest} from "../../../model/api/field-request";
import {FormFieldConfig} from "../../../model/api/form-field-config";
import {CommonFieldService} from "../../../services/common/common-field.service";
import {CrudBaseComponent} from "../../../crystal-elements/crud/crud-base.component";
import {BankAccount} from "../../../model/customer/bank-account";
import {CustomerBankAccountService} from "../../../services/customer/customer-bank-account.service";
import TYPE = FormFieldConfig.TYPE;

@Component({
  selector: 'app-bank-acct',
  templateUrl: './bank-account.component.html',
  encapsulation: ViewEncapsulation.None,
  providers: [
    MessageService,
    ConfirmationService,
    TranslateService,
  ],
})
export class BankAccountComponent extends CrudBaseComponent<BankAccount> {

  //fields
  owners: FieldRecord<any>[]

  constructor(cdref: ChangeDetectorRef,
              customerBankAccountService: CustomerBankAccountService,
              commonFieldService: CommonFieldService,
              componentFactoryResolver: ComponentFactoryResolver,
              messageService: MessageService,
              confirmationService: ConfirmationService,
              translateService: TranslateService) {
    super(cdref, messageService, confirmationService, translateService, commonFieldService);
    this.crudService = customerBankAccountService;
    this.newRecord = new BankAccount();
  }

  protected initConfigs() {
    super.initConfigs();

    this.tableConfig = [
      {
        field: 'ownerCode',
      },
      {
        field: 'bankAccountCode',
      },
      {
        field: 'swiftAccount',
      },
      {
        field: 'accountName',
      },
      {
        field: 'accountNumber',
      },
    ];

    this.formConfig = [
      {
        group: '',
        fields: [
          {
            field: 'ownerCode',
            optionValue: 'text',
            required: true,
            filter: true,
            column: 6,
            type: TYPE.DROPDOWN,
            options: () => this.owners,
            changed: event => {
              this.formRecord.ownerCode = event.value;
            }
          },
          {
            field: 'bankAccountCode',
            required: true,
            column: 6,
            type: TYPE.TEXT
          },
          {
            field: 'accountName',
            column: 6,
            type: TYPE.TEXT
          },
          {
            field: 'accountNumber',
            column: 6,
            type: TYPE.TEXT
          },
          {
            field: 'swiftAccount',
            column: 6,
            type: TYPE.TEXT
          },
          {
            field: 'fedWire',
            column: 6,
            type: TYPE.TEXT
          }]
      },
    ];
  }

  protected initData() {
    super.initData();

    this.formLoading = false;
    this.commonFieldService.getOwners(FieldRequest.DEFAULT()).subscribe(fieldResult => {
      this.owners = this.getFields(fieldResult);
      this.formLoading = false;
    })
  }

  onFormShow() {
  }
}
